export default __webpack_public_path__ + "static/low-ac9f3767fe2345312a5dd7fa448eac7d.png";